import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Maria R.", city: "Bologna", initials: "MR", text: "Finalmente posso andare a fare la spesa da sola. Consegna puntuale e assistenza gentilissima." },
  { name: "Giuseppe T.", city: "Torino", initials: "GT", text: "Comodo e protetto anche con la pioggia. Ordine confermato online senza stress, come promesso." },
  { name: "Anna L.", city: "Napoli", initials: "AL", text: "Mio padre ha ritrovato la sua autonomia. Personale disponibile e tempi di consegna rispettati." },
];

export const ReviewsBar = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10 lg:py-14" data-testid="reviews-bar">
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center sm:text-left">
      <div className="flex items-center gap-2">
        <div className="flex" aria-label="Valutazione 4,9 su 5">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star key={i} size={22} className="fill-amber-400 text-amber-400" />
          ))}
        </div>
        <span className="text-lg font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>4,9/5</span>
      </div>
      <span className="hidden sm:block w-px h-8 bg-slate-200" />
      <p className="text-slate-600"><strong className="text-slate-900">2.300+</strong> clienti soddisfatti in tutta Italia</p>
    </div>

    <div className="mt-8 grid md:grid-cols-3 gap-5">
      {REVIEWS.map((r) => (
        <div key={r.name} className="relative rounded-2xl bg-white border border-slate-200 p-6 shadow-sm" data-testid={`review-${r.initials}`}>
          <Quote size={26} className="text-[var(--sc-emerald)] opacity-30" />
          <p className="mt-2 text-slate-700 leading-relaxed">{r.text}</p>
          <div className="mt-4 flex items-center gap-3">
            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: "var(--sc-emerald)" }}>{r.initials}</span>
            <div className="text-left">
              <p className="font-bold text-slate-900 text-sm">{r.name}</p>
              <p className="text-slate-500 text-xs">{r.city}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
